/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyPasswordSetupTokenDto
 */
export interface VerifyPasswordSetupTokenDto {
    /**
     * 
     * @type {boolean}
     * @memberof VerifyPasswordSetupTokenDto
     */
    isValid?: boolean;
    /**
     * 
     * @type {string}
     * @memberof VerifyPasswordSetupTokenDto
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyPasswordSetupTokenDto
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyPasswordSetupTokenDto
     */
    lastName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof VerifyPasswordSetupTokenDto
     */
    expiresAt?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof VerifyPasswordSetupTokenDto
     */
    message?: string | null;
}

/**
 * Check if a given object implements the VerifyPasswordSetupTokenDto interface.
 */
export function instanceOfVerifyPasswordSetupTokenDto(value: object): value is VerifyPasswordSetupTokenDto {
    return true;
}

export function VerifyPasswordSetupTokenDtoFromJSON(json: any): VerifyPasswordSetupTokenDto {
    return VerifyPasswordSetupTokenDtoFromJSONTyped(json, false);
}

export function VerifyPasswordSetupTokenDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyPasswordSetupTokenDto {
    if (json == null) {
        return json;
    }
    return {
        
        'isValid': json['isValid'] == null ? undefined : json['isValid'],
        'email': json['email'] == null ? undefined : json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function VerifyPasswordSetupTokenDtoToJSON(json: any): VerifyPasswordSetupTokenDto {
    return VerifyPasswordSetupTokenDtoToJSONTyped(json, false);
}

export function VerifyPasswordSetupTokenDtoToJSONTyped(value?: VerifyPasswordSetupTokenDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isValid': value['isValid'],
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'expiresAt': value['expiresAt'] == null ? value['expiresAt'] : value['expiresAt'].toISOString(),
        'message': value['message'],
    };
}

